import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons'
import { Radio, Spin } from 'antd'
import {
  IQuestion,
  IQuestionLikert,
  IQuestionMultipleChoice,
} from 'models/evaluation.model'
import { evaluationsService } from 'api/courses/evaluations'
import { QuestionTypes } from 'enum'
import { useEvaluation } from '../../../contexts/Evaluation'
import { Wrapper, Answer } from './styled'

interface IProps {
  question: IQuestion
}

export const Answers = ({ question }: IProps) => {
  const {
    evaluation,
    updateSections,
    savingQuestions,
    setSavingQuestion,
    isSectionsInReviewMode,
    previewMode,
  } = useEvaluation()
  const evaluationResponseId = evaluation.evaluationResponse?.id
  const isSaving = savingQuestions[question.id] || false
  const disabled = isSectionsInReviewMode || previewMode

  const saveUserAnswer = (
    question: IQuestionLikert | IQuestionMultipleChoice,
    newAnswer: IQuestion['userAnswer']
  ) => {
    if (disabled) return
    if (!evaluationResponseId) return

    const lastUserAnswer = question.userAnswer

    if (
      !isSectionsInReviewMode &&
      lastUserAnswer?.response !== newAnswer?.response
    ) {
      updateSections(question.id, newAnswer)
      setSavingQuestion(question.id, true)
      evaluationsService
        .saveUserAnswer(evaluationResponseId, question.id, newAnswer)
        .catch(() => {
          setSavingQuestion(question.id, false)
          updateSections(question.id, lastUserAnswer)
        })
        .finally(() => {
          setSavingQuestion(question.id, false)
        })
    }
  }

  if (question.type === QuestionTypes.open) return null

  return (
    <Spin spinning={isSaving}>
      <Wrapper>
        {question.answers.map((answer, index) => {
          const isUserAnswer = question.userAnswer?.response === answer.id
          const correct =
            isSectionsInReviewMode && isUserAnswer && answer.correct === true
          const incorrect =
            isSectionsInReviewMode && isUserAnswer && answer.correct === false

          return (
            <Answer
              key={index}
              onClick={() => saveUserAnswer(question, { response: answer.id })}
              disabled={disabled}
              correct={correct}
              incorrect={incorrect}
            >
              {correct || incorrect ? (
                <FontAwesomeIcon
                  icon={correct ? faCircleCheck : faCircleXmark}
                />
              ) : (
                <Radio
                  checked={question.userAnswer?.response === answer.id}
                  disabled={disabled}
                  style={{ marginRight: 0, paddingRight: '8px' }}
                />
              )}
              <div>{answer.text}</div>
            </Answer>
          )
        })}
      </Wrapper>
    </Spin>
  )
}

export default Answers
